module.exports = __webpack_public_path__ + "static/media/logo.1fba3daf.png";